import React, {useState, useEffect, useCallback }  from 'react';
import { slide as SlideMenu } from 'react-burger-menu'
import { useSelector } from 'react-redux'
import { filter, find } from 'ramda';
import { FixedSizeList as List } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";


import {
  useParams,
  useLocation,
} from "react-router-dom";

import { selectAllHorses } from '../reducers/horsesReducer';

import './Menu.scss';

import MenuTop from './MenuTop';
import HorseIndex from './HorseIndex';
import { selectSale } from '../reducers/salesReducer';

const menuStyles = {
    bmCrossButton: {
      display: 'none',
    },
    bmCross: {
      background: '#bdc3c7'
    },
    bmMenuWrap: {
      position: 'fixed',
      height: '100%'
    },
    bmMenu: {
      background: '#c2c3c6',
      fontSize: '1.15em',
      overflow: 'hidden',
    },
  }

const GUTTER_SIZE = 4;
const Row = ({ index, style, data }) => {
  const horse = data.horsesToUse[index];

  return (
    <HorseIndex horse={horse} sale={data.sale} style={{
      ...style,
      top: style.top + GUTTER_SIZE,
      height: style.height - GUTTER_SIZE,
      left: '1%',
      width: '98%',
    }}
    consignorIDInt={data.consignorIDInt}
    onClick={data.closeIndex}
    />
  );
}

// Hook
function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    // Add event listener
    window.addEventListener("resize", handleResize);
    
    // Call handler right away so state gets updated with initial window size
    handleResize();
    
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}

function getConsignorID(pathParts) {
  if(pathParts.length < 3) {
    return null;
  }

  if (pathParts[1] === 'consignor') {
    return parseInt(pathParts[2], 10);
  }

  let output = parseInt(pathParts[1], 10)
  if(Number.isNaN(output)) {
    return null;
  }
  return output;
}

const Menu = ({ ...props}) => {
  const size = useWindowSize();
  let location = useLocation();
  const pathParts = location.pathname.split('/');
  let consignorIDInt = getConsignorID(pathParts);
  const consignorObj = find((c) => parseInt(c.consignor_id, 10) === consignorIDInt)(global.drupalSettings.catalogues.consignors_contacts);
  const main_color = consignorObj && consignorObj.main_color || global.drupalSettings.catalogues.main_color;
  const secondary_color = consignorObj && consignorObj.secondary_color || global.drupalSettings.catalogues.secondary_color;
  const [menuOpen, setMenuOpen] = useState(false);
  const [showShortList, setShortList] = useState(false);
  const horses = useSelector(selectAllHorses);
  const sale = useSelector(selectSale);
  const closeIndex = useCallback(() => {
    setMenuOpen(false);
  }, []);
  const favoritedHorses = useSelector(state => {
    let consignorFiltered = state.horses
    if (consignorIDInt) {
      consignorFiltered = filter((h) => h.consignor_id == consignorIDInt)(consignorFiltered);
    }
    const favoritedHorses = filter(horse => horse.favorited)(consignorFiltered);
    return favoritedHorses;
  });

  let horsesToUse = showShortList ? favoritedHorses : horses;
  if (consignorIDInt) {
    horsesToUse = filter((h) => h.consignor_id == consignorIDInt)(horsesToUse);
  }

  
  const lockOpen = location.pathname === '/sale' || location.pathname === '/sale/' ? size.width > 1300 : false;

  const styles = `
    .horse-index:hover, .horse-index .hip-number, .horse-index .out-box {
      background-color: ${main_color};
    }

    .horse-index:hover .out-box {
      color: ${main_color} !important;
      background-color: #ffffff !important;
    }

    .horse-index:hover .favorite svg {
      color: #ffffff !important;
    }
  `;
  return (
    <>
      <style>
        {styles}
      </style>
      <SlideMenu 
        isOpen={lockOpen || menuOpen}
        onClose={ () => {setMenuOpen(lockOpen || false); setShortList(false);} }
        {...props}
        styles={ menuStyles }
        customBurgerIcon={ false } width={ '350px' }
        noOverlay={lockOpen}
      >
        <MenuTop
          favoritedHorses={favoritedHorses}
          horses={horsesToUse}
          sale={sale}
          consignorIDInt={consignorIDInt}
          showingFavorites={showShortList} 
        />
        <AutoSizer>
          {({ height, width }) => (
            <List
              className="List"
              height={height - 210}
              itemCount={horsesToUse.length}
              itemSize={70 + GUTTER_SIZE}
              width={width}
              itemData={{
                consignorIDInt: consignorIDInt,
                horsesToUse,
                sale,
                closeIndex,
              }}
            >
              {Row}
            </List>
          )}
        </AutoSizer>
      </SlideMenu>
      <div className="index-controls"
        style={{
          left: menuOpen || lockOpen ? 15 : -335,
        }}
      >
        <button
          style={{
            visibility: favoritedHorses.length === 0 ? 'hidden' : null,
            backgroundColor: main_color,
            width: 175
          }}
          onClick={() => { setMenuOpen(!menuOpen || (menuOpen && !showShortList) ? true : false); setShortList(true); }}
        >
          {lockOpen || !menuOpen || (menuOpen && !showShortList) ? 'Show ' : 'Hide '}Shortlist
        </button>
        <button
          style={{
            backgroundColor: main_color,
          }}
          onClick={() => { setMenuOpen(!menuOpen || (menuOpen && showShortList) ? true : false); setShortList(false); }}
        >
          {lockOpen || !menuOpen || (menuOpen && showShortList) ? 'Show ' : 'Hide '}Index
        </button>
      </div>
    </>
  );
}


export default Menu;
